import axios from 'axios'
import { message } from 'antd'
import { envHttpUrl } from '../../http/globalMethod'

// 2026-10-22 coder(lq): 参照 menuApiPermission 的独立会话封装：
// 全局 apiGetRequest/apiPostRequest 会先弹 notification 再 reject，且 GET 的 reject 丢失 status，
// 既无法精确识别 403，也会和本页要求的 message.error 形成双重提示。
// 这里统一处理信封、403、登录失效和网络异常，并在同一处 message.error，页面只处理状态。
export const FORBIDDEN_MESSAGE = '没有 CLI 能力目录管理权限'
export const UNAUTHORIZED_MESSAGE = '登录状态已失效，请重新登录'
const PAGE_ROUTER_URL = '/admin/cliCatalog'
const CATALOG_PREFIX = '/lechun-baseservice/cliAdmin/catalog'
const client = axios.create({ withCredentials: true, timeout: 15000 })
let lastForbiddenAt = 0

function createError(text, status) {
    const error = new Error(text)
    error.status = status
    return error
}

function resolveBaseUrl() {
    const baseUrl = (envHttpUrl() || {}).baseUrl
    if (!baseUrl) throw createError('当前环境没有配置管理接口地址', 0)
    return `${window.location.protocol}${baseUrl}`
}

// 后端权限不通过有两种可能：网关 HTTP 403，或服务内 NoSecurityException 返回 status=403 的信封。
function mapEnvelopeError(payload, httpStatus) {
    if (Number(httpStatus) === 403) return createError(FORBIDDEN_MESSAGE, 403)
    if (!payload || typeof payload !== 'object') return null
    const status = Number(payload.status)
    if (status === 403) return createError(FORBIDDEN_MESSAGE, 403)
    if (status === 20112) return createError(UNAUTHORIZED_MESSAGE, 20112)
    if (payload.status !== undefined && status !== 200) {
        return createError(payload.message || payload.msg || '请求失败，请稍后重试', status)
    }
    return null
}

async function request(path, { method = 'GET', data, params } = {}) {
    let response
    try {
        response = await client.request({
            baseURL: resolveBaseUrl(),
            url: `${CATALOG_PREFIX}/${path}`,
            method,
            data,
            params: { ...(params || {}), pageRouterUrl: PAGE_ROUTER_URL },
        })
    } catch (error) {
        const responseData = error && error.response ? error.response.data : null
        const mapped = mapEnvelopeError(responseData, error && error.response && error.response.status)
        if (mapped) throw mapped
        if (error && error.response) throw createError('管理接口请求失败，请稍后重试', error.response.status)
        if (error && typeof error.message === 'string' && error.status === 0) throw error
        throw createError('网络异常，请稍后重试', 0)
    }
    const payload = response.data
    if (!payload || typeof payload !== 'object' || payload.status === undefined) {
        throw createError('管理接口响应格式不正确，请稍后重试', response.status)
    }
    const mapped = mapEnvelopeError(payload, response.status)
    if (mapped) throw mapped
    return payload.value
}

async function call(path, options) {
    try {
        return await request(path, options)
    } catch (error) {
        const text = error && error.message ? error.message : '请求失败，请稍后重试'
        // 页面加载时条目/文档两个请求同时 403，只提示一次，避免同一权限问题弹两条。
        if (error && Number(error.status) === 403 && Date.now() - lastForbiddenAt < 1000) throw error
        if (error && Number(error.status) === 403) lastForbiddenAt = Date.now()
        message.error(text)
        throw error
    }
}

/** 能力条目分页：keyword 匹配名称/编码/场景，kind、enabled 可空。 */
export const getCatalogItems = params => call('items', { params })
/** 单个能力条目，编辑时取最新值。 */
export const getCatalogItem = id => call('item', { params: { id } })
export const saveCatalogItem = data => call('item/save', { method: 'POST', data })
/** 启用/停用，enabled 传 1/0，不物理删除。 */
export const toggleCatalogItem = (id, enabled) => call('item/toggle', { method: 'POST', data: { id, enabled } })
/** 文档列表，返回 [{topic,title,version,enabled,updateTime,updateBy}]。 */
export const getCatalogDocs = () => call('docs')
/** 单个 topic 的 Markdown 正文。 */
export const getCatalogDoc = topic => call('doc', { params: { topic } })
export const saveCatalogDoc = data => call('doc/save', { method: 'POST', data })
export const getCatalogDocHistory = params => call('doc/history', { params })
/** 回滚到指定历史版本，服务端会写入一条新版本，不删除历史。 */
export const restoreCatalogDoc = data => call('doc/restore', { method: 'POST', data })
